import {
  ADD_CATEGORY,
  REMOVE_CATEGORIES,
  GET_CATEGORIES,
  GET_CATEGORY,
  GET_CATEGORIES_WITH_IDS,
  ADD_PRODUCTS_TO_CATEGORIES,
  REMOVE_PRODUCTS_FROM_CATEGORIES,
  GET_CATEGORIES_FOR_PRODUCT,
  UPDATE_CATEGORY_NAME,
  GET_PRODUCT_GROUPS_FOR_CATEGORY
} from "../constants/action-types";

import Axios from "axios";

import { getApiConfig } from "../../config/apiConfig";
import { adalApiFetch } from "../../config/azureConfig";
const API_CONFIG = getApiConfig();

/* 
  Add categories.
*/
export const addCategory = (category, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/categories`, {
    method: "post",
    data: category
  })
    .then(res => {
      const categoryId = res.data;

      category.id = categoryId;

      dispatch({
        type: ADD_CATEGORY,
        payload: category
      });

      callback(true);
    })
    .catch(error => {
      console.log(`Exception Occurred: ${error}`);
      callback(false);
    });
};

/*
  Remove categories.
*/
export const removeCategories = (categories, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/categories`, {
    method: "delete",
    data: categories
  })
    .then(res => {
      dispatch({
        type: REMOVE_CATEGORIES,
        payload: categories
      });

      callback(true);
    })
    .catch(error => {
      console.log(`Exception Occurred: ${error}`);
      callback(false);
    });
};

/*
  Get categories.
*/
export const getCategories = callback => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/categories`, {
    method: "get"
  })
    .then(res => {
      dispatch({
        type: GET_CATEGORIES,
        payload: res.data.categories
      });

      callback(true);
    })
    .catch(error => {
      console.log(`Exception Occurred: ${error}`);
      callback(false);
    });
};

/*
  Get categories.
*/

export const getCategoriesForIds = (categoryIds, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/categories?forIds=true`, {
    method: "post",
    data: categoryIds
  })
    .then(res => {
      dispatch({
        type: GET_CATEGORIES_WITH_IDS,
        payload: res.data.categories
      });

      callback(true);
    }).catch((error) => {
      console.log(`Exception Occurred: ${error}`);
      callback(false);
    })
}

/*
  Get categories for a product.
*/
export const getCategoriesForProduct = (productId, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/product/${productId}/categories`, {
    method: "get"
  })
    .then(res => {
      dispatch({
        type: GET_CATEGORIES_FOR_PRODUCT,
        payload: res.data.categoriesForProduct
      });

      callback(true);
    })
    .catch(error => {
      console.log(`Exception Occurred: ${error}`);
      callback(false);
    });
};

/*
  Get categories.
*/
export const getCategory = (categoryId, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/categories/${categoryId}`, {
    method: "get"
  })
    .then(res => {
      dispatch({
        type: GET_CATEGORY,
        payload: res.data.category
      });

      callback(true);
    })
    .catch(error => {
      console.log(`Exception Occurred: ${error}`);
      callback(false);
    });
};

/*
  Get categories.
*/
export const updateCategoryName = (
  categoryId,
  newName,
  callback
) => dispatch => {


  adalApiFetch(Axios, `${API_CONFIG.URL}/categories/${categoryId}`, {
    method: "put",
    data: { data: newName }
  })
    .then(res => {
      dispatch({
        type: UPDATE_CATEGORY_NAME,
        payload: { categoryId, newName }
      });

      callback(true);
    })
    .catch(error => {
      console.log(`Exception Occurred: ${error}`);
      callback(false);
    });
};

/* 
  Add product to categories.
*/
export const addProductsToCategories = (
  productIds,
  categoryIds,
  callback
) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/categories/products`, {
    method: "post",
    data: { productIds: productIds, categoryIds: categoryIds }
  })
    .then(res => {
      dispatch({
        type: ADD_PRODUCTS_TO_CATEGORIES,
        payload: { productIds, categoryIds }
      });

      callback(true);
    })
    .catch(error => {
      console.log(`Exception Occurred: ${error}`);
      callback(false);
    });
};

/* 
  Remove product from categories.
*/
export const removeProductsFromCategories = (
  productIds,
  categoryIds,
  callback
) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/categories/products`, {
    method: "delete",
    data: { productIds: productIds, categoryIds: categoryIds }
  })
    // Axios.delete(
    //   `${API_CONFIG.URL}/categories/products`,
    //   { data: { productIds: productIds, categoryIds: categoryIds } }
    // )
    .then(res => {
      dispatch({
        type: REMOVE_PRODUCTS_FROM_CATEGORIES,
        payload: { productIds, categoryIds }
      });

      callback(true);
    })
    .catch(error => {
      console.log(`Exception Occurred: ${error}`);
      callback(false);
    });
};


/* 
  Get product groups from category. TODO: Check inclusive type?
*/
export const getProductGroupsForCategory = (categoryId, inclusiveType, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/categories/${categoryId}/productGroups?inclusiveType=${inclusiveType}`, {
    method: "get"
  })
    .then(res => {
      dispatch({
        type: GET_PRODUCT_GROUPS_FOR_CATEGORY,
        payload: { data: res.data.productGroups, inclusiveType }
      });

      callback(true);
    }).catch((error) => {
      console.log(`Exception Occurred: ${error}`);
      callback(false);
    })
}